/**
 * @generated SignedSource<<09089ce68e67c6040325d239b63c43e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LeaveWaitlistInput = {
  gameId: string;
};
export type WaitlistButtonLeaveMutation$variables = {
  input: LeaveWaitlistInput;
};
export type WaitlistButtonLeaveMutation$data = {
  readonly leaveWaitingList: {
    readonly game: {
      readonly viewerIsOnWaitingList: boolean;
    } | null;
  } | null;
};
export type WaitlistButtonLeaveMutation = {
  variables: WaitlistButtonLeaveMutation$variables;
  response: WaitlistButtonLeaveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsOnWaitingList",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WaitlistButtonLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeaveWaitingListPayload",
        "kind": "LinkedField",
        "name": "leaveWaitingList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Game",
            "kind": "LinkedField",
            "name": "game",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WaitlistButtonLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeaveWaitingListPayload",
        "kind": "LinkedField",
        "name": "leaveWaitingList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Game",
            "kind": "LinkedField",
            "name": "game",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c543984aa729bf826cd22304b4df9937",
    "id": null,
    "metadata": {},
    "name": "WaitlistButtonLeaveMutation",
    "operationKind": "mutation",
    "text": "mutation WaitlistButtonLeaveMutation(\n  $input: LeaveWaitlistInput!\n) {\n  leaveWaitingList(input: $input) {\n    game {\n      viewerIsOnWaitingList\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67f9001961537a88595c88678e1aee41";

export default node;
